import styled from 'styled-components';

const Label = styled.label`
	position: relative;
	color: #6f7879;
	font-weight: bold;
	font-size: 0.813rem;
	width: 100%;
`;
export default Label;
